var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "save-as-template-modal",
        centered: "",
        "hide-header": "",
        "hide-footer": "",
        "body-class": "p-0",
        "content-class": "dg-modal-content",
      },
    },
    [
      _c(
        "div",
        { staticClass: "dg-modal" },
        [
          _c("div", { staticClass: "dg-header" }, [
            _c("div", { staticClass: "dg-header-icon" }, [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", { attrs: { d: "M20 3v4" } }),
                  _vm._v(" "),
                  _c("path", { attrs: { d: "M22 5h-4" } }),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", [
              _c("h5", { staticClass: "dg-title" }, [
                _vm._v("\n          Save as Template\n        "),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "dg-subtitle" }, [
                _vm._v("\n          Save as a reusable template.\n        "),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "dg-close-btn",
                attrs: { disabled: _vm.isLoading },
                on: { click: _vm.closeModal },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "18",
                      height: "18",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  },
                  [
                    _c("line", {
                      attrs: { x1: "18", y1: "6", x2: "6", y2: "18" },
                    }),
                    _c("line", {
                      attrs: { x1: "6", y1: "6", x2: "18", y2: "18" },
                    }),
                  ]
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "dg-tabs" }, [
            _c(
              "button",
              {
                staticClass: "dg-tab",
                class: { "dg-tab--active": _vm.activeTab === 0 },
                on: {
                  click: function ($event) {
                    _vm.activeTab = 0
                  },
                },
              },
              [
                _c(
                  "svg",
                  {
                    staticClass: "dg-tab-icon",
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "14",
                      height: "14",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z",
                      },
                    }),
                    _c("path", { attrs: { d: "M20 3v4" } }),
                    _c("path", { attrs: { d: "M22 5h-4" } }),
                    _c("path", { attrs: { d: "M4 17v2" } }),
                    _c("path", { attrs: { d: "M5 18H3" } }),
                  ]
                ),
                _vm._v("\n        Basic\n      "),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "dg-tab",
                class: { "dg-tab--active": _vm.activeTab === 1 },
                on: {
                  click: function ($event) {
                    _vm.activeTab = 1
                  },
                },
              },
              [
                _c(
                  "svg",
                  {
                    staticClass: "dg-tab-icon",
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  },
                  [
                    _c("path", { attrs: { d: "M20 7h-9" } }),
                    _c("path", { attrs: { d: "M14 17H5" } }),
                    _c("circle", { attrs: { cx: "17", cy: "17", r: "3" } }),
                    _c("circle", { attrs: { cx: "7", cy: "7", r: "3" } }),
                  ]
                ),
                _vm._v("\n        Advanced\n      "),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "b-overlay",
            { attrs: { show: _vm.isLoading, variant: "white" } },
            [
              _c("div", { staticClass: "dg-body" }, [
                _vm.activeTab === 0
                  ? _c("div", [
                      _c("div", { staticClass: "dg-field" }, [
                        _c("div", { staticClass: "dg-field-label-row" }, [
                          _c("label", { staticClass: "dg-label" }, [
                            _vm._v("Name"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "dg-link-btn",
                              attrs: { disabled: _vm.isLoading },
                              on: { click: _vm.pasteProjectName },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass:
                                    "lucide lucide-clipboard-paste h-3 w-3",
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "14",
                                    height: "14",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M15 2H9a1 1 0 0 0-1 1v2c0 .6.4 1 1 1h6c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1Z",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2M16 4h2a2 2 0 0 1 2 2v2M11 14h10",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: { d: "m17 10 4 4-4 4" },
                                  }),
                                ]
                              ),
                              _vm._v(
                                "\n                Paste Project Name\n              "
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.templateName,
                              expression: "templateName",
                            },
                          ],
                          staticClass: "dg-input",
                          attrs: { placeholder: "Enter template name..." },
                          domProps: { value: _vm.templateName },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.templateName = $event.target.value
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "dg-field" }, [
                        _c("label", { staticClass: "dg-label" }, [
                          _vm._v("Type"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "dg-chips" },
                          _vm._l(_vm.typeOptions, function (option) {
                            return _c(
                              "button",
                              {
                                key: option.value,
                                staticClass: "dg-chip",
                                class: {
                                  "dg-chip--active":
                                    _vm.selectedType === option.value,
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.selectedType = option.value
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(option.label) +
                                    "\n              "
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "dg-field" }, [
                        _c("label", { staticClass: "dg-label" }, [
                          _vm._v("Style"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "dg-chips" },
                          _vm._l(_vm.styleOptions, function (option) {
                            return _c(
                              "button",
                              {
                                key: option.value,
                                staticClass: "dg-chip",
                                class: {
                                  "dg-chip--active":
                                    _vm.selectedStyle === option.value,
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.selectedStyle = option.value
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(option.label) +
                                    "\n              "
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "rounded-md border bg-muted/30 p-2 dg-gallery-toggle",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex items-start gap-2 dg-gallery-toggle-inner",
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.isAlsoAddToDesignGallery,
                                    expression: "isAlsoAddToDesignGallery",
                                  },
                                ],
                                staticClass: "dg-checkbox",
                                attrs: {
                                  id: "save-template-also-gallery",
                                  type: "checkbox",
                                },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.isAlsoAddToDesignGallery
                                  )
                                    ? _vm._i(
                                        _vm.isAlsoAddToDesignGallery,
                                        null
                                      ) > -1
                                    : _vm.isAlsoAddToDesignGallery,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.isAlsoAddToDesignGallery,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.isAlsoAddToDesignGallery =
                                            $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.isAlsoAddToDesignGallery = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.isAlsoAddToDesignGallery = $$c
                                    }
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "dg-gallery-toggle-label",
                                  attrs: { for: "save-template-also-gallery" },
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      staticClass:
                                        "lucide lucide-image-plus h-3.5 w-3.5 text-primary",
                                      attrs: {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "14",
                                        height: "14",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        "stroke-width": "2",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                      },
                                    },
                                    [
                                      _c("path", { attrs: { d: "M16 5h6" } }),
                                      _c("path", { attrs: { d: "M19 2v6" } }),
                                      _c("path", {
                                        attrs: {
                                          d: "M21 11.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7.5",
                                        },
                                      }),
                                      _c("path", {
                                        attrs: {
                                          d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21",
                                        },
                                      }),
                                      _c("circle", {
                                        attrs: { cx: "9", cy: "9", r: "2" },
                                      }),
                                    ]
                                  ),
                                  _vm._v(
                                    "\n                Also add to Design Gallery\n              "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.activeTab === 1
                  ? _c("div", [
                      _c("div", { staticClass: "dg-field" }, [
                        _c("label", { staticClass: "dg-label" }, [
                          _vm._v("Customer"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.customerId,
                                expression: "customerId",
                              },
                            ],
                            staticClass: "dg-input",
                            attrs: { disabled: !_vm.customersList.length },
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.customerId = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                            },
                          },
                          _vm._l(_vm.customersList, function (customer) {
                            return _c(
                              "option",
                              {
                                key: customer.id,
                                domProps: { value: customer.id },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(customer.name) +
                                    "\n              "
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "dg-field" }, [
                        _c("label", { staticClass: "dg-label" }, [
                          _vm._v("Tags"),
                        ]),
                        _vm._v(" "),
                        _c("small", { staticClass: "dg-hint" }, [
                          _vm._v(
                            "Type and Style (set on Basic) are also tags. Add more here."
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "dg-tag-chips" },
                          [
                            _c(
                              "span",
                              { staticClass: "dg-tag-chip dg-tag-chip--base" },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.selectedTypeLabel) +
                                    "\n                "
                                ),
                                _c(
                                  "span",
                                  { staticClass: "dg-tag-chip-kind" },
                                  [_vm._v("type")]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "dg-tag-chip dg-tag-chip--base" },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.selectedStyleLabel) +
                                    "\n                "
                                ),
                                _c(
                                  "span",
                                  { staticClass: "dg-tag-chip-kind" },
                                  [_vm._v("style")]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.selectedExtraTags, function (tag) {
                              return _c(
                                "span",
                                { key: tag, staticClass: "dg-tag-chip" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(tag) +
                                      "\n                "
                                  ),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "dg-tag-chip-remove",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeExtraTag(tag)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "12",
                                            height: "12",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            stroke: "currentColor",
                                            "stroke-width": "2",
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                          },
                                        },
                                        [
                                          _c("path", {
                                            attrs: { d: "M18 6 6 18" },
                                          }),
                                          _c("path", {
                                            attrs: { d: "m6 6 12 12" },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "dg-tag-input-row" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.customTagInput,
                                expression: "customTagInput",
                              },
                            ],
                            staticClass: "dg-input dg-input--sm",
                            attrs: { placeholder: "Add a tag..." },
                            domProps: { value: _vm.customTagInput },
                            on: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                $event.preventDefault()
                                return _vm.addTagFromInput.apply(
                                  null,
                                  arguments
                                )
                              },
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.customTagInput = $event.target.value
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "dg-tag-add-btn",
                              attrs: { type: "button" },
                              on: { click: _vm.addTagFromInput },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                  },
                                },
                                [
                                  _c("path", { attrs: { d: "M5 12h14" } }),
                                  _c("path", { attrs: { d: "M12 5v14" } }),
                                ]
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "dg-tag-suggestions" },
                          _vm._l(_vm.availableTagOptions, function (tag) {
                            return _c(
                              "button",
                              {
                                key: `tag-opt-${tag}`,
                                staticClass: "dg-tag-suggestion",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return _vm.addExtraTag(tag)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                + " +
                                    _vm._s(tag) +
                                    "\n              "
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "dg-field" }, [
                        _c("label", { staticClass: "dg-section-label" }, [
                          _vm._v("EXPORT"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "dg-row" }, [
                          _c(
                            "div",
                            { staticClass: "dg-field dg-field--third" },
                            [
                              _c("label", { staticClass: "dg-label" }, [
                                _vm._v("File Type"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.fileType,
                                      expression: "fileType",
                                    },
                                  ],
                                  staticClass: "dg-input",
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.fileType = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                _vm._l(_vm.fileTypeOptions, function (option) {
                                  return _c(
                                    "option",
                                    {
                                      key: option.value,
                                      domProps: { value: option.value },
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(option.text) +
                                          "\n                  "
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "dg-field dg-field--third" },
                            [
                              _c("label", { staticClass: "dg-label" }, [
                                _vm._v("DPI"),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.number",
                                    value: _vm.dpi,
                                    expression: "dpi",
                                    modifiers: { number: true },
                                  },
                                ],
                                staticClass: "dg-input",
                                attrs: { type: "number", min: "1" },
                                domProps: { value: _vm.dpi },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.dpi = _vm._n($event.target.value)
                                  },
                                  blur: function ($event) {
                                    return _vm.$forceUpdate()
                                  },
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "dg-field dg-field--third" },
                            [
                              _c("label", { staticClass: "dg-label" }, [
                                _vm._v("Max Size (KB)"),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.number",
                                    value: _vm.maxFileSize,
                                    expression: "maxFileSize",
                                    modifiers: { number: true },
                                  },
                                ],
                                staticClass: "dg-input",
                                attrs: { type: "number", min: "1" },
                                domProps: { value: _vm.maxFileSize },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.maxFileSize = _vm._n(
                                      $event.target.value
                                    )
                                  },
                                  blur: function ($event) {
                                    return _vm.$forceUpdate()
                                  },
                                },
                              }),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "dg-field" },
                        [
                          _c("label", { staticClass: "dg-section-label" }, [
                            _vm._v("THUMBNAIL"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "dg-row dg-row--align-end" },
                            [
                              _c(
                                "div",
                                { staticClass: "dg-field dg-field--third" },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "dg-label dg-label--sm",
                                      attrs: { for: "thumbnail-width" },
                                    },
                                    [_vm._v("Max Width")]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model.number",
                                        value: _vm.thumbnailWidth,
                                        expression: "thumbnailWidth",
                                        modifiers: { number: true },
                                      },
                                    ],
                                    staticClass: "dg-input",
                                    attrs: {
                                      id: "thumbnail-width",
                                      type: "number",
                                      min: "1",
                                      max: _vm.maxThumbnailWidth,
                                    },
                                    domProps: { value: _vm.thumbnailWidth },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.thumbnailWidth = _vm._n(
                                          $event.target.value
                                        )
                                      },
                                      blur: function ($event) {
                                        return _vm.$forceUpdate()
                                      },
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "dg-field dg-field--third" },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "dg-label dg-label--sm",
                                      attrs: { for: "thumbnail-height" },
                                    },
                                    [_vm._v("Max Height")]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model.number",
                                        value: _vm.thumbnailHeight,
                                        expression: "thumbnailHeight",
                                        modifiers: { number: true },
                                      },
                                    ],
                                    staticClass: "dg-input",
                                    attrs: {
                                      id: "thumbnail-height",
                                      type: "number",
                                      min: "1",
                                      max: _vm.maxThumbnailHeight,
                                    },
                                    domProps: { value: _vm.thumbnailHeight },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.thumbnailHeight = _vm._n(
                                          $event.target.value
                                        )
                                      },
                                      blur: function ($event) {
                                        return _vm.$forceUpdate()
                                      },
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "dg-field dg-field--third" },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "dg-btn dg-btn--outline dg-btn--block dg-btn--field-size",
                                      on: {
                                        click: _vm.generateTemplateThumbnail,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Generate new\n                "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "dg-upload-link-row" }, [
                            _c(
                              "button",
                              {
                                staticClass: "dg-upload-link",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return _vm.showImageTools({ upload: true })
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                or upload image...\n              "
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.showUploadSection
                            ? _c("b-form-file", {
                                staticClass: "mt-3",
                                attrs: { accept: "image/*" },
                                on: { input: _vm.handleImageChange },
                                model: {
                                  value: _vm.image,
                                  callback: function ($$v) {
                                    _vm.image = $$v
                                  },
                                  expression: "image",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isImageToolsVisible && _vm.templateImagePreview
                            ? _c("PreviewableImage", {
                                staticClass: "mt-3",
                                attrs: {
                                  src: _vm.templateImagePreview,
                                  alt: "template-thumbnail",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.image
                            ? _c("div", { staticClass: "mt-3" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "dg-btn dg-btn--primary dg-btn--block",
                                    attrs: { disabled: _vm.isLoading },
                                    on: { click: _vm.updateThumbnailOnly },
                                  },
                                  [
                                    _vm._v(
                                      "\n                Update Template Thumbnail\n              "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "dg-checkbox-row" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.isUpdateExistingTemplate,
                              expression: "isUpdateExistingTemplate",
                            },
                          ],
                          staticClass: "dg-checkbox",
                          attrs: {
                            id: "save-update-existing",
                            type: "checkbox",
                          },
                          domProps: {
                            checked: Array.isArray(_vm.isUpdateExistingTemplate)
                              ? _vm._i(_vm.isUpdateExistingTemplate, null) > -1
                              : _vm.isUpdateExistingTemplate,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.isUpdateExistingTemplate,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.isUpdateExistingTemplate = $$a.concat([
                                      $$v,
                                    ]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.isUpdateExistingTemplate = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.isUpdateExistingTemplate = $$c
                              }
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "dg-checkbox-label",
                            attrs: { for: "save-update-existing" },
                          },
                          [_vm._v("Update existing template")]
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "dg-footer" }, [
            _vm.template?.id
              ? _c("small", { staticClass: "dg-gallery-id" }, [
                  _vm._v("Template ID: " + _vm._s(_vm.template.id)),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "dg-footer-actions" }, [
              _c(
                "button",
                {
                  staticClass: "dg-btn dg-btn--ghost",
                  attrs: { disabled: _vm.isLoading },
                  on: { click: _vm.closeModal },
                },
                [_vm._v("\n          Cancel\n        ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "dg-btn dg-btn--primary",
                  attrs: { disabled: _vm.isSaveDisabled || _vm.isLoading },
                  on: { click: _vm.handleSave },
                },
                [
                  _vm._v(
                    "\n          " + _vm._s(_vm.saveButtonText) + "\n        "
                  ),
                ]
              ),
            ]),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }